import React, { useState } from "react";
import "./styles/Navbar.css"; 

function Navbar() {
  const [copied, setCopied] = useState(false);
  const CA_ADDRESS = "0x3D72DDD35cadb4e5B22CDB20b36f98077BE84284";

  const handleCopy = () => {
    navigator.clipboard.writeText(CA_ADDRESS).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="navbar">
      {/* New Links */}
      <a
        href="https://memedepot.com/d/god-the-dog"
        target="_blank"
        rel="noopener noreferrer"
        className="nav-button"
      >
        MEMES
      </a>
      <a
        href="https://giphy.com/channel/godthedog"
        target="_blank"
        rel="noopener noreferrer"
        className="nav-button"
      >
        GIFS
      </a>


      <button className="nav-button ca-button" onClick={handleCopy}>
        CA
        {copied && <span className="copied-text">Copied!</span>}
      </button>
    </div>
  );
}

export default Navbar;
